import {EVerificationStatus} from 'src/containers/Channels/Verification/definitions';

export default {
  company: 'Компания',
  filters: {
    status: 'Статус запроса',
    manager: 'Ответственный менеджер',
    searchPlaceholder: 'быстрый поиск по Business Portfolio ID',
    period: 'Выберите период',
  },
  status: {
    [EVerificationStatus.DRAFT]: 'Черновик',
    [EVerificationStatus.MANAGER_REVIEW]: 'Требует проверки',
    [EVerificationStatus.NEEDS_CORRECTION]: 'Требует доработки',
    [EVerificationStatus.PENDING]: 'На верификации в Meta',
    [EVerificationStatus.APPROVED]: 'Верификация пройдена',
    [EVerificationStatus.REJECTED]: 'Верификация отклонена',
    [EVerificationStatus.REJECTED_PERMANENTLY]: 'Верификация в кабинете невозможна',
  },
  view: 'Просмотреть',
  check: 'Проверить',
  send: 'Отправить на верификацию',
  return: 'Вернуть на доработку',
  checkBanner: {
    title: 'Как проверить запрос на верификацию:',
    steps: [
      'Убедитесь, что документы, веб-сайт и бизнес-портфолио содержат точную информацию о компании (название, адрес, номер телефона).',
      'Подтвердите, что деятельность клиента соответствует политике WhatsApp. Проверке подлежат только компании, соответствующие требованиям.',
      'Если вы обнаружите какие-либо проблемы или несоответствия, свяжитесь с клиентом и предоставьте четкие рекомендации по улучшению заявки или документов.',
    ],
  },
};
